<template>
    <div class="studentPopup">
        <div class="popup">
            <p class="name">{{name}}同学，你好~</p>
            <p class="detail">为了能更好的进行学业规划服务，我们需要先对你的个人情况进行了解，请你根据自己的真实情况完善个人普查信息问卷中的问题。</p>
            <p class="detail">回答主观问题时请简要回答，字数控制在200字以内。若不存在题中所述情况，请填写“无”。</p>
            <div class="btn"  @click="$emit('closePop')">
                开始填写
            </div>
            <div class="close" @click="$emit('closePop')"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "studentPopup",
    props:['name']
}
</script>

<style scoped lang="less">
    .studentPopup {
        background: rgba(153, 153, 153, 0.8);
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        .popup {
            box-sizing: border-box;
            padding: 84px 40px 0 40px;
            width: 575px;
            height: 434px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -287px;
            margin-top: -217px;
            background: url("/imgs/xueyezixun/studentAndParent/popup.png");
            .name {
                line-height: 30px;
                color: #fff;
                font-weight: 500;
                margin-bottom: 120px;
                font-size: 20px;
            }
            .detail {
                line-height: 20px;
                margin-bottom: 20px;
            }
        }
        .btn {
            width: 146px;
            height: 40px;
            line-height: 40px;
            cursor: pointer;
            background: #3D90F6;
            border-radius: 4px;
            text-align: center;
            margin: 0 auto;
            color: #fff;
        }
        .close {
            width: 36px;
            height: 36px;
            position: absolute;
            top: 0px;
            right: 2px;
            cursor: pointer;
        }

    }
</style>